export function shouldShowExtraPHQ9Fields(
  littleInterestInDoingThings: number | undefined | null = 0,
  feelingDownDepressedOrHopeless: number | undefined | null = 0
) {
  return (
    (littleInterestInDoingThings ?? 0) +
      (feelingDownDepressedOrHopeless ?? 0) >=
    3
  );
}
